import { syncCollect } from '@widget/tool'
export default {
    data () {
        return {
            'accountVOEUrl': 'ppdloanapp://dynamicrouter/router3?templateType=12&source=xxx&needAuth=true&closePage=false&launchChannel=app'
        }
    },
    created () {
    },
    mounted () {
        this.accountVOEUrl = syncCollect(this.accountVOEUrl, {
            'page': 'MGM',
            'position': 'evaluatePop',
            'idea': '0',
            'source': '0'
        })
    },
    'methods': {
        onLoanClick () {
            if (window.PPDWebUI && window.PPDWebUI.os.inApp) {
                window.PPDWebUI.CommonService.openUrl({ 'url': this.accountVOEUrl })
            } else {
                window.location.href = this.accountVOEUrl
            }
        }
    }
}
